import { render, staticRenderFns } from "./TriviaScratchOut.vue?vue&type=template&id=6fdc0e30&"
import script from "./TriviaScratchOut.vue?vue&type=script&lang=js&"
export * from "./TriviaScratchOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports